"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DisorderAbilityHandler = exports.DisorderActorAbilityFactory = exports.DisorderAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
const Duration_1 = require("../../core/Duration");
const core_1 = require("../../core/effects/core");
const AbilityDamage_1 = require("../../core/AbilityDamage");
class DisorderAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.Disorder;
        this.__typeName = "Disorder";
    }
}
exports.DisorderAbilityArgs = DisorderAbilityArgs;
let DisorderActorAbilityFactory = class DisorderActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("Disorder", "AllEnemies", 4);
    }
};
DisorderActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("Disorder")
], DisorderActorAbilityFactory);
exports.DisorderActorAbilityFactory = DisorderActorAbilityFactory;
let DisorderAbilityHandler = class DisorderAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        container.applyMultiAttack({
            sequence,
            attackType: "ranged",
            abilityKey: ability.args.__typeName,
            attackerId: ability.invokerId,
            targets: container.selectLivingTargets(ability.invokerId, Target_1.Target.AllEnemies)
                .map((targetId) => ({
                jitter: 0,
                targetId,
                damages: [
                    AbilityDamage_1.AbilityDamage.Power("Physical", 90)
                ],
                effects: [
                    {
                        targetId,
                        duration: Duration_1.Duration.Turns(1),
                        effect: new core_1.StunEffectArgs()
                    }
                ],
            }))
        });
    }
};
DisorderAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.Disorder)
], DisorderAbilityHandler);
exports.DisorderAbilityHandler = DisorderAbilityHandler;
